export const PUBLICATION_DATE = `02.01.2025`
